import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TailwindThemeService } from '@backoffice-frontend/shared/ui-tailwind';
import { NotificationService } from '@clean-code/notifications/domain';
import { SplashScreenService } from '@clean-code/shared/common';
import { RegisterUserLimitViolationNotificationType } from '@clean-code/user-limit/ui-violation-notification';
// eslint-disable-next-line @nx/enforce-module-boundaries
import tailwindThemeConfig from '../../../frontoffice/src/assets/config/tailwind-theme.config.json'; //TODO: CHECK ESLINT ERROR
import { environment } from '../environments/environment';
@Component({
    selector: 'clean-code-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [CommonModule, RouterModule]
})
export class AppComponent {
  title = 'frontoffice-int';
  private splashState = inject(SplashScreenService);
  public showSplash$ = this.splashState.showSplash$;

  constructor(titleService: Title) {
    const tailwindService = inject(TailwindThemeService);
    const notificationService = inject(NotificationService);
    RegisterUserLimitViolationNotificationType(notificationService);

    tailwindService.loadConfig(tailwindThemeConfig);
    titleService.setTitle(environment.name);
  }
}
